import { render, staticRenderFns } from "./ManagePasswordModal.vue?vue&type=template&id=3bc4a3a4&scoped=true"
import script from "./ManagePasswordModal.vue?vue&type=script&lang=js"
export * from "./ManagePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ManagePasswordModal.vue?vue&type=style&index=0&id=3bc4a3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4a3a4",
  null
  
)

export default component.exports